import { Link, useLocation } from 'react-router-dom';

// material-ui
import { ButtonBase } from '@mui/material';
import Logo from 'ui-component/Logo';
import { departments } from 'constants';

// ==============================|| MAIN LOGO ||============================== //

const LogoSection = () => {
    const location = useLocation();

    const firstPart = location.pathname.split('/')[1]

    const link = departments.includes(firstPart)
        ? `/${firstPart}`
        : `/dashboard/default`;

    return (
        <ButtonBase disableRipple component={Link} to={link}>
            <Logo />
        </ButtonBase>
    );
};
export default LogoSection;
